import { Injectable, Inject } from '@angular/core';

@Injectable()
export class SessionService {

    private sessionId: string;

    public generateSessionId() {
      const rand = Math.floor(Math.random() * (1000000 - 1)) + 1;

      this.sessionId = new Date().getTime().toString() + '-' + rand.toString();
    }

    public getSessionId(): string {
      return this.sessionId;
    }
}
